/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentPasswordResponseParser = 
/* #__PURE__ */ parsers.object([
    ['password', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AssignmentPasswordResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPasswordResponseParser.decode(input).map(res => new AssignmentPasswordResponse(res));
    }
    static unsafeDecode(input) {
        return AssignmentPasswordResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPasswordResponseParser.encode(data);
    }
    static schema() {
        return AssignmentPasswordResponseParser.schema();
    }
}
